module.exports = __webpack_public_path__ + "static/media/SCBpayments.8e2ad7e5.svg";